<template>
  <!-- 购买后服务清单 -->
  <div class="buy_service_list">
    <div class="buy_title">购买后服务清单</div>
    <div class="buy_body">
      <div class="header">
        <div class="main_title df-center">
          <img src="../../assets/images/serviceList/i-star.png" alt="" />
          <span>使用支持服务</span>
          <img src="../../assets/images/serviceList/i-star.png" alt="" />
        </div>
        <div class="sub_title">院内各科室全覆盖同步使用的推广执行计划服务</div>
      </div>
      <div class="content">
        <div class="desc">
          专属客服顾问将根据医院的实际情况与需求，协助制定院内推广计划及按计划实施；同时解决在产品使用过程中的问题：
        </div>
        <div class="product_list">
          <div
            class="product_item df-between"
            v-for="(item, index) in buyList"
            :key="index"
          >
            <div
              class="product_item_child d-flex"
              v-for="(item2, index2) in item.list"
              :key="index2"
            >
              <div class="icon_box x-center">
                <img :src="item2.img" alt="" />
              </div>
              <div class="product_desc flex-1">
                {{ item2.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 购买后服务清单
      buyList: [
        {
          id: "",
          list: [
            {
              id: "",
              img: require("../../assets/images/serviceList/i-list-1.png"),
              title: "1对1专属客户成功专员",
            },
            {
              id: "",
              img: require("../../assets/images/serviceList/i-list-2.png"),
              title: "纸质查检表转为电子表服务",
            },
          ],
        },
        {
          id: "",
          list: [
            {
              id: "",
              img: require("../../assets/images/serviceList/i-list3.png"),
              title: "在线客服7*10在线",
            },
            {
              id: "",
              img: require("../../assets/images/serviceList/i-list4.png"),
              title: "制度/培训课件/试题上传服务",
            },
          ],
        },
        {
          id: "",
          list: [
            {
              id: "",
              img: require("../../assets/images/serviceList/i-list5.png"),
              title: "导入员工名单和 机构组织",
            },
            {
              id: "",
              img: require("../../assets/images/serviceList/i-list6.png"),
              title: "使用指导及院内使用推广培训",
            },
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
    .buy_service_list {
    height: 554px;
    box-sizing: border-box;
    padding: 30px 12px 0;
    .buy_title {
      margin-bottom: 30px;
      font-size: 18px;
      font-family: SourceHanSansCN, SourceHanSansCN-Bold;
      font-weight: 700;
      text-align: center;
      color: #333333;
      line-height: 24px;
    }
    .buy_body {
      height: 426px;
      opacity: 1;
      background: #ffffff;
      overflow: hidden;
      border-radius: 10px;
      box-shadow: 0px 0px 8px 0px rgba(81, 116, 143, 0.16);
      .header {
        height: 85px;
        background: url("../../assets/images/serviceList/bg-list.png");
        background-size: 100% 100%;
        box-sizing: border-box;
        padding-top: 13px;
        .main_title {
          margin-bottom: 10px;
          span {
            font-size: 20px;
            margin: 0 15px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            text-align: left;
            color: #ffffff;
            line-height: 28px;
          }
          img {
            width: 16px;
            height: 14px;
          }
        }
        .sub_title {
          color: #ffffff;
          text-align: center;
        }
      }
      .content {
        box-sizing: border-box;
        padding: 15px 10px 0;
        .desc {
          margin-bottom: 30px;
          box-sizing: border-box;
          padding: 0 5px;
          color: #666666;
        }
        .product_list {
          .product_item {
            width: 100%;
            margin-bottom: 15px;
            .product_item_child {
              justify-content: center;
              width: 160px;
              height: 60px;
              opacity: 1;
              overflow: hidden;
              background: #f5f9ff;
              border-radius: 5px;
              .icon_box {
                flex-shrink: 0;
                box-sizing: border-box;
                width: 48px;
                height: 60px;
                background: #1c91ff;
                img {
                  margin-top: 15px;
                  width: 27px;
                  height: 27px;
                }
              }
              .product_desc {
                margin-top: 10px;
                // height: 100%;
                box-sizing: border-box;
                padding: 0 4px 0 6px;
                font-size: 14px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                text-align: left;
                color: #333333;
              }
            }
          }
        }
      }
    }
  }
</style>
